<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_page', 'product_information_action')"
    :side="'right'"
    @on-side-menu-close="$emit('onProductInformationClose')"
  >
    <div class="bg-main h-full flex flex-col">
      <div class="md:px-24 px-16 pt-28 overflow-y-auto mb-80">
        <div class="mb-24">
          <h6 class="normal-case font-medium mb-8">
            {{ $lang('product_page', 'product_description') }}
          </h6>
          <div class="text-sm" v-html="product.description" />
        </div>
        <div class="mb-24">
          <h6 class="normal-case font-medium mb-8">
            {{ $lang('product_page', 'product_material') }}
          </h6>
          <div class="text-sm">
            <span class="block mb-2">{{ product.material }}</span>
            <span class="block mb-2">{{ $lang('product_page', 'sku') }}: {{ product.sku }}</span>
            <span v-if="product.color && !product.hideColorChoice" class="block mb-2">
              {{ $lang('product_page', 'color') }}: {{ product.variantName }}
            </span>
            <span v-if="product.composition(country)" class="block mb-2">
              {{ $lang('product_page', 'composition') }}:
              {{ product.composition(country) }}
            </span>
            <p v-if="product.washing && product.washing.text.length > 3" class="mb-12">
              {{ product.washing.text }}
            </p>
            <img
              v-if="product.washing.image"
              class="h-56 w-[unset] max-w-full"
              :src="product.washing.image.url"
            >
          </div>
        </div>
        <div v-if="product.modelSize" class="mb-24">
          <h6 class="normal-case font-medium mb-8">
            {{ $lang('product_page', 'fit') }}
          </h6>
          <div class="text-sm">
            <p>{{ product.modelSize.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </SideMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';
import Product from '~/models/product';

export default defineComponent({
  components: {
    SideMenu,
  },
  props: {
    product: {
      type: Product,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    country(): string {
      return this.$accessor('config', 'market', 'country').toLowerCase();
    },
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
  },
});
</script>
